<template>
  <div class="practice-empty-pending">
    <div class="practice-empty-pending__grid"></div>
    <div class="practice-empty-pending__content">
      <div class="pending-figure">
        <img class="pending-figure__logo" :src="logoIcon" />
        <div class="pending-figure__shadow"></div>
      </div>
      <div class="pending-title">
        <i class="icon-sparkling-2-fill t-iconfont"></i>
        <span>AI 智能分析中...</span>
      </div>
      <div class="pending-desc">预计 1-2 min，无需在此等候</div>
    </div>
  </div>
</template>

<script setup>
const logoIcon = require('@/assets/ai.svg')
</script>

<style lang="less" scoped>
.practice-empty-pending {
  box-sizing: border-box;
  /* token: 线条/Line-2 一般线条 */
  --pending-border-color: #e5e6eb;
  /* token: 线条/Line-1 浅线条 */
  --pending-grid-color: #f2f3f5;
  /* token: 文字/Text-4 强调正文标题 */
  --pending-title-color: #323233;
  /* token: 文字/Text-2 次要信息 */
  --pending-desc-color: #969799;
  /* token: 填充/淡底色 */
  --pending-bg-color: #f8faff;
  /* token: 拓展渐变 */
  --pending-accent-gradient: linear-gradient(314deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);

  position: relative;
  width: 100%;
  height: 100%;
  border: 1px solid var(--pending-border-color);
  border-radius: 20px;
  overflow: hidden;
  background: var(--pending-bg-color);

  &__grid {
    position: absolute;
    inset: 0;
    opacity: 0.6;
    background-image:
      linear-gradient(to right, var(--pending-grid-color) 1px, transparent 1px),
      linear-gradient(to bottom, var(--pending-grid-color) 1px, transparent 1px),
      radial-gradient(circle at center, rgba(248, 250, 255, 0.8) 0%, var(--pending-bg-color) 78%);
    background-size:
      16px 16px,
      16px 16px,
      100% 100%;
    background-position:
      0 0,
      0 0,
      center;
  }

  &__content {
    position: relative;
    z-index: 1;
    min-height: 406px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .pending-figure {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__logo {
      width: 72px;
      height: 72px;
      object-fit: contain;
    }

    &__shadow {
      width: 48px;
      height: 8px;
      margin-top: 8px;
      border-radius: 50%;
      background: radial-gradient(
        circle at center,
        rgba(0, 0, 0, 0.15) 0%,
        rgba(0, 0, 0, 0.02) 88%
      );
    }
  }

  .pending-title {
    margin-top: 12px;
    display: flex;
    align-items: center;
    color: var(--pending-title-color);
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;

    .t-iconfont {
      margin-right: 8px;
      font-size: 16px;
      background: var(--pending-accent-gradient);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    }
  }

  .pending-desc {
    margin-top: 2px;
    color: var(--pending-desc-color);
    font-size: 13px;
    line-height: 18px;
  }
}
</style>
